<template>
  <div class="row">

    <div class="col-md-12">
      <create-transaction-form @on-submit="onCreateTransactionSubmit"></create-transaction-form>
    </div>
  </div>
</template>
<script>
  import CreateTransactionForm from './Forms/CreateTransactionForm.vue'

  export default {
    components: {
      CreateTransactionForm
    },
    data () {
      return {

        createTransactionModel: {}
      }
    },
    methods: {

      onCreateTransactionSubmit (model, isValid) {
        model.saveTransactionButtonText = 'Updating Transaction ...'
        
        this.$http.put('/transactions/' + this.$route.params.id, {
          
          transaction_date: model.transactionDate,
          amount: model.amount,
          remark: model.description,
          type_id: model.transactionType,
          category_id: model.category_id,
          bank_id: '3',
          account_number: '0039392311',
        })
        .then(response =>{
          if(response.data.created_at){
            model.saveTransactionButtonText = 'Transaction Saved.'

          }else{
            model.saveTransactionButtonText = 'Transaction Was Not Saved.'
          }
        })
        .catch(error => {
          console.error(error);
        });
      },

      getTransactionID () {
        var currentTimestamp = Date.now()
        return currentTimestamp
      }
    }
  }
</script>
<style>
</style>
